export const DELAY_FOR_ENTER_PRESS = 300;
export const TIME_SPAN_FOR_SAME_SEARCH = 10;
